/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Box } from '@mui/material';
import appTheme from '../common/theme/appTheme.json';
import { useDispatch } from 'react-redux';
import { FLEET_MAP_ID, setMapHidden } from '../../store/maps/actions';

interface PlansBodyWrapperProps {
  children: React.ReactNode;
  hideMissionPlanTitle?: boolean;
  title?: React.ReactNode | string;
}

export const INFO_BANNER_HEIGHT = 40;
export const MISSION_PLAN_TITLE_HEIGHT = 76;
export const HEADER_BUFFER_HEIGHT = 52;

function PlansBodyWrapper({ children, hideMissionPlanTitle, title }: PlansBodyWrapperProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    // hide the fleet/FTV view map in the case of refresh on any MPT page
    dispatch(setMapHidden(FLEET_MAP_ID)(true));
  }, [dispatch]);

  return (
    <Box>
      {!hideMissionPlanTitle && (
        <StyledMptDiv>
          <StyledMptH1>{title}</StyledMptH1>
        </StyledMptDiv>
      )}
      {children}
    </Box>
  );
}

export default PlansBodyWrapper;

const StyledMptDiv = styled.div`
  background-color: ${appTheme.mptPrimaryBackgroundColor}
  width: 100%;
  height: ${MISSION_PLAN_TITLE_HEIGHT}px;
  line-height: ${MISSION_PLAN_TITLE_HEIGHT}px;
  display: flex;
  align-items: center;
`;

const StyledMptH1 = styled.h1`
  font-family: ${appTheme.viasatFontFamilyRegular};
  color: ${appTheme.primaryTextColor};
  font-size: 28px;
  font-weight: 800;
  margin-left: 16px;
  letter-spacing: 0.2px;
  margin-top: 0px;
  margin-bottom: 0px;

  @media print {
    margin-left: 0px;
  }
`;
